<div class="kt-card max-w-[370px] w-full mx-auto">
  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="kt-card-content flex flex-col gap-5 p-10">
    <div class="text-center mb-2.5">
      <h3 class="text-lg font-medium text-mono leading-none mb-2.5">Set a New Password</h3>
      <span class="text-sm text-secondary-foreground">Almost done, create a new password.</span>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="text-red-500 text-sm italic text-center">
        {{ errorMessage }}
      </div>
    }

    <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">New Password</label>
      <div class="kt-input" [ngClass]="{'border-red-500': changePasswordForm.get('password')?.touched && changePasswordForm.get('password')?.invalid}">
        <input formControlName="password" placeholder="Enter new password" [type]="passwordVisible ? 'text' : 'password'"/>
        <button class="kt-btn kt-btn-sm kt-btn-ghost kt-btn-icon bg-transparent! -me-1.5"
                type="button" (click)="togglePasswordVisibility('password')">
          @if (!passwordVisible) {
            <span><i class="ki-filled ki-eye text-muted-foreground"></i></span>
          } @else {
            <span><i class="ki-filled ki-eye-slash text-muted-foreground"></i></span>
          }
        </button>
      </div>
      @if (changePasswordForm.get('password')?.touched && changePasswordForm.get('password')?.hasError('minlength')) {
        <span class="text-xs text-red-500">Password must be at least 8 chars</span>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">Confirm New Password</label>
      <div class="kt-input" [ngClass]="{'border-red-500': (changePasswordForm.get('confirmPassword')?.touched && changePasswordForm.get('confirmPassword')?.invalid) || (changePasswordForm.hasError('mismatch') && changePasswordForm.get('confirmPassword')?.touched)}">
        <input formControlName="confirmPassword" placeholder="Re-enter new password" [type]="confirmPasswordVisible ? 'text' : 'password'"/>
        <button class="kt-btn kt-btn-sm kt-btn-ghost kt-btn-icon bg-transparent! -me-1.5"
                type="button" (click)="togglePasswordVisibility('confirm')">
          @if (!confirmPasswordVisible) {
             <span><i class="ki-filled ki-eye text-muted-foreground"></i></span>
          } @else {
             <span><i class="ki-filled ki-eye-slash text-muted-foreground"></i></span>
          }
        </button>
      </div>
      @if (changePasswordForm.hasError('mismatch') && changePasswordForm.get('confirmPassword')?.touched) {
        <span class="text-xs text-red-500">Passwords do not match</span>
      }
    </div>

    <button [disabled]="isLoading || !uid || !token" class="kt-btn kt-btn-primary flex justify-center grow" type="submit">
      @if (!isLoading) {
        <span>Submit</span>
      } @else {
        <span>Verifying...</span>
      }
    </button>
  </form>
</div>
